var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_12444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_12444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3333 5C25.7017 5 27.0176 5.52591 28.0091 6.46896C29.0005 7.41202 29.5916 8.70006 29.66 10.0667L29.6667 10.3333V21C29.6667 22.3683 29.1408 23.6843 28.1977 24.6757C27.2547 25.6672 25.9666 26.2583 24.6 26.3267L24.3333 26.3333H8.33333C6.96501 26.3333 5.64903 25.8074 4.65758 24.8644C3.66614 23.9213 3.07508 22.6333 3.00667 21.2667L3 21V10.3333C3 8.96501 3.52591 7.64903 4.46896 6.65758C5.41202 5.66614 6.70005 5.07508 8.06667 5.00667L8.33333 5H24.3333ZM17.0093 11.6667L16.756 11.672C15.5187 11.7413 14.464 12.4493 13.6667 13.5973C12.92 12.524 11.9493 11.8347 10.8147 11.6933L10.5507 11.6707L10.332 11.6667L10.1187 11.6733C8.412 11.788 7 13.2453 7 15C7 16.6347 8.62933 17.948 10.2707 18.2627L10.484 18.2973L8.724 20.0573L8.61333 20.1827C8.43191 20.4165 8.33344 20.704 8.33344 21C8.33344 21.296 8.43191 21.5835 8.61333 21.8173L8.724 21.9427L8.84933 22.0533C9.08316 22.2348 9.37071 22.3332 9.66667 22.3332C9.96262 22.3332 10.2502 22.2348 10.484 22.0533L10.6093 21.9427L13.6667 18.8867L16.724 21.9427L16.8493 22.0533C17.1059 22.2522 17.4262 22.3506 17.7501 22.3302C18.0741 22.3098 18.3795 22.1718 18.609 21.9423C18.8385 21.7128 18.9764 21.4074 18.9969 21.0835C19.0173 20.7595 18.9189 20.4392 18.72 20.1827L18.6093 20.0573L16.8493 18.2973C18.488 18.072 20.1853 16.8173 20.324 15.2107L20.3333 15L20.3267 14.7827C20.22 13.1973 18.9667 11.9 17.4267 11.6947L17.2147 11.6733L17.0093 11.6667ZM16.976 14.3333L17.112 14.3453C17.3707 14.3987 17.6013 14.6253 17.6547 14.8867L17.6667 15L17.6507 15.0413L17.6053 15.0947C17.432 15.2747 16.9213 15.5867 16.4907 15.6547L16.3333 15.6667H15.5307L15.6 15.5333L15.7173 15.3253C16.0773 14.7333 16.4827 14.3973 16.8533 14.3413L16.976 14.3333ZM10.3573 14.3333L10.4693 14.34L10.5947 14.3667C10.9333 14.4693 11.292 14.7933 11.6147 15.324L11.7347 15.5333L11.8013 15.6667H11L10.8587 15.656C10.328 15.58 9.66667 15.1227 9.66667 15C9.66667 14.6933 9.92533 14.4053 10.2213 14.3453L10.3573 14.332V14.3333Z",
    fill: "#FFAA01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification2Icon);
export default __webpack_public_path__ + "static/media/notification2-icon.567c873300581f5686e967f24a79bd05.svg";
export { ForwardRef as ReactComponent };